export type NaturalFlowScrollDirection = 'backward' | 'forward' | null

export function resolveNaturalFlowScrollDirection(
    previousScrollTop: number | null,
    scrollTop: number,
): NaturalFlowScrollDirection {
    if (
        previousScrollTop == null ||
        !Number.isFinite(previousScrollTop) ||
        !Number.isFinite(scrollTop) ||
        previousScrollTop === scrollTop
    ) {
        return null
    }
    return scrollTop > previousScrollTop ? 'forward' : 'backward'
}

export function resolveNaturalFlowRootMargin({
    backwardRootMargin,
    direction,
    fallbackRootMargin,
    forwardRootMargin,
}: {
    backwardRootMargin?: string
    direction: NaturalFlowScrollDirection
    fallbackRootMargin: string
    forwardRootMargin?: string
}) {
    if (direction === 'forward') return forwardRootMargin || fallbackRootMargin
    if (direction === 'backward') return backwardRootMargin || fallbackRootMargin
    return fallbackRootMargin
}
